import React, { useState, useCallback, useEffect } from "react";
import Gallery from "react-photo-gallery";
import FadeIn from "react-fade-in";
import Carousel, { Modal, ModalGateway } from "react-images";
import { DrawerSchema } from "schemas";
import { useRecoilValue } from "recoil";
import { GeneralFetch } from "Api/generalFetch/generalFetch";
import imagg from '../../assets/safety/empty.jpg'

export default function GalleryComponent({ setLoading, refetch, activeKey }) {
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);
    const [images, setImages] = useState([]);
    const { fetchData, loading } = GeneralFetch()
    const drawer = useRecoilValue(DrawerSchema)
    const url = 'https://5.189.154.152/api/uploads/'

    useEffect(() => {
        setLoading(loading)
    }, [loading])

    useEffect(() => {
        setImages([])
        const fetchDataAsync = async () => {
            await fetchData({
                object: drawer.object,
                object_id: drawer?.data?.objectId,
                evidenciaFecho: activeKey == 2
            }, 'getEvidencias', 'post', 'evidencias').then((images) => {
                let updated = images?.evidencias.map((image) => {
                    return {
                        src: `${url}${image.path}`,
                        className: "imgg",
                    }
                })

                setImages(updated)
            })
        }

        void fetchDataAsync();
    }, [drawer.data, refetch, activeKey])

    const openLightbox = useCallback((event, { photo, index }) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    }, []);

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    return (
        <FadeIn>
            {images?.length > 0 ?
                <>
                    <Gallery imageGit={"cover"} photos={images} onClick={openLightbox} />
                    <ModalGateway style={{ zIndex: "20000001" }} >
                        {viewerIsOpen ? (
                            <Modal style={{ zIndex: "20000001" }} onClose={closeLightbox}>
                                <Carousel
                                    currentIndex={currentImage}
                                    views={images.map(x => ({
                                        ...x,
                                        srcset: x.srcSet,
                                        caption: x.title
                                    }))}
                                />
                            </Modal>
                        ) : null}
                    </ModalGateway>
                </>

                :
                <div style={{ display: "flex", justifyContent: "center" }} >
                    <img style={{ width: "250px", height: "170px" }} src={imagg} />
                </div>
            }
        </FadeIn>
    );
}
